<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="table-wrapper">
                    <span class="sa-flexbox-body-title">Parametri Vitali</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovaMisurazione" class="mb-2">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>
                    <b-table ref="table" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left class="sa-b-table text-center" thead-tr-class="sa-riga-orari">
                        <template #thead-top>
                            <b-tr class="sa-riga-date">
                                <b-th colspan="2" class="border-bottom-0 border-top-0 colonna-vuota-top-left"></b-th>
                                <b-th v-for="(gruppo, index) in dateGroups" :key="'date-' + index" :colspan="gruppo.count" class="text-center sa-header-data">
                                    {{ gruppo.date }}
                                </b-th>
                            </b-tr>
                        </template>
                        <template #cell(index)="row">
                            {{ row.index + 1 }}
                        </template>
                        <template #cell(tipo)="{ item }">
                            <div class="contenuto-attivita">
                                <strong>{{ getLabelTraduora(item.tipo) }}</strong>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>

            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <rsa-paziente-parametri-vitali-edit-modal-component ref="mdlRsaPazienteParametriVitaliEdit" @saveSuccess="onSaveSuccess"></rsa-paziente-parametri-vitali-edit-modal-component>
        <rsa-paziente-parametri-vitali-view-modal-component ref="mdlRsaPazienteParametriVitaliView"></rsa-paziente-parametri-vitali-view-modal-component>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
// import axios from "axios";
import RsaPazienteParametriVitaliEditModalComponent from "./RsaPazienteParametriVitaliEditModalComponent.vue";
import RsaPazienteParametriVitaliViewModalComponent from "./RsaPazienteParametriVitaliViewModalComponent.vue";
export default {
    props: {},
    watch: {
        currentPage() {
            let me = this;
            let filtro = {};
            filtro.idPaziente = me.idAccettazione;
            filtro.dataAl = new Date().getTime() + 24 * 60 * 60 * 1000;
            filtro.dataDal = filtro.dataAl - 30 * 24 * 60 * 60 * 1000;
            me.loadData();
        },
    },
    mixins: [UtilityMixin],
    components: { RsaPazienteParametriVitaliEditModalComponent, RsaPazienteParametriVitaliViewModalComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            listKey: 0,
            items: [],
            pathResource: "/pazientemisure",
            linkedit: "/",
            filterItems: [],
            filtroSpesaExtra: {},
            accettazione: {},
            parametriRaggruppati: {},
            colonneTabella: [],
            showModalLoading: false,
            idAccettazione: "",
            dateGroups: [],
            fields: [],
        };
    },
    mounted() {},
    methods: {
        loadData(filtro, accettazione = null) {
            let me = this;
            me.$emit("beforeLoadData");
            filtro.dal = me.formatDateTimeCustom(filtro.dataDal, "YYYY-MM-DD HH:mm:ss");
            filtro.al = me.formatDateTimeCustom(filtro.dataAl, "YYYY-MM-DD HH:mm:ss");
            if (accettazione !== null) {
                me.accettazione = accettazione;
            }
            this.loadDataResources(me.pathResource, filtro, me.loadDataSuccess, null);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data;
            me.rows = me.items.length;
            this.raggruppaParametriVitali(me.items);
            me.$emit("afterLoadData");
        },
        loadDataError(response) {
            console.log(response);
        },
        onClickAggiornaParametriVitali(item) {
            let me = this;
            me.$refs.mdlRsaPazienteParametriVitaliEdit.show(item.id);
        },
        onClickDeleteParametriVitali(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", { title: "Eliminazione Parametri Vitali", buttonSize: "sm", okVariant: "secondary", cancelVariant: "danger", okTitle: "SI", cancelTitle: "NO", footerClass: "p-2", hideHeaderClose: false, centered: true })
                .then((value) => {
                    if (value) {
                        me.deleteParametriVitali(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteParametriVitali(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            UtilityMixin.methods.restCallDelete(link, me.resultDeleteResponse, me.resultDeleteError);
        },
        resultDeleteResponse(response) {
            let me = this;
            me.$emit("onDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", { title: "Successo", variant: "success", solid: true });
            me.loadData();
        },
        resultDeleteError(error) {
            let me = this;
            console.log(error);
            me.showModalLoading = false;
            me.$bvToast.toast("Errore durante l'eliminazione", { title: "Errore", variant: "danger", solid: true });
        },
        onClickView(item) {
            let me = this;
            me.$refs.mdlRsaPazienteParametriVitaliView.show(item.id);
        },
        onClickNuovaMisurazione() {
            let me = this;
            me.idAccettazione = this.$route.query.idAccettazione;

            let url = process.env.VUE_APP_PATH_API + "/rsaaccettazioni/" + me.idAccettazione;

            axios
                .get(url)
                .then((response) => {
                    let accettazione = response.data.data;
                    if (accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" || accettazione.statoAttuale === "ASSENTE" || accettazione.statoAttuale === "SOSPESO_ADI") {
                        let messaggio = accettazione.statoAttuale === "SOSPESO_ADI" ? "Non è possibile questa operazione su un paziente con percorso ADI sospeso" : accettazione.statoAttuale === "DIMISSIONE" || accettazione.statoAttuale === "TRASFERITO" ? "Non è possibile questa operazione su un paziente dimesso" : "Non è possibile questa operazione su un paziente assente";
                        me.$bvModal.msgBoxOk(messaggio, { title: "ATTENZIONE", size: "sm", okVariant: "outline-danger", headerClass: "sa-msg-header-danger", footerClass: "p-2 border-top-0", centered: true });
                        return;
                    }
                    me.$refs.mdlRsaPazienteParametriVitaliEdit.show(null, accettazione.idPresidio);
                })
                .catch((error) => {
                    console.error("Errore nel recupero dati accettazione:", error);
                    me.$bvToast.toast("Errore nel recupero dei dati del paziente.", { title: "Errore", variant: "danger", solid: true });
                });
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("sucessRestCall", response);
            me.$emit("onAfterSave");
            me.loadData();
        },
        saveErrorResponse(response) {
            let me = this;
            if (response.response.status === 400) {
                this.$bvModal.msgBoxOk(response.response.data.messaggio, { title: "ATTENZIONE", size: "sm", okVariant: "outline-danger", headerClass: "sa-msg-header-danger", footerClass: "p-2 border-top-0", centered: true });
            } else {
                me.$bvToast.toast("Errore nel salvataggio" + response.message, { title: "Errore", variant: "danger", solid: true });
            }
        },
        onSaveSuccess() {
            let me = this;
            let filtro = {};
            filtro.idPaziente = this.$route.query.idAccettazione;
            filtro.dataAl = new Date().getTime() + 24 * 60 * 60 * 1000;
            filtro.dataDal = filtro.dataAl - 30 * 24 * 60 * 60 * 1000;
            me.loadData(filtro);
        },
        raggruppaParametriVitali(listaParametri) {
            const dati = listaParametri.map((m) => ({
                ts: Number(m.createDate),
                tipo: m.measurename,
                valore: m.value,
            }));
            const timestampOrdinati = [...new Set(dati.map((d) => d.ts))].sort((a, b) => b - a);
            const gruppiDiDate = [];
            let lastDate = null;

            const colonne = [
                {
                    key: "index",
                    label: " ",
                    thClass: "colonna-fissa-indice align-middle text-center",
                    tdClass: "colonna-fissa-indice text-center",
                    thStyle: {
                        width: "10px",
                        minWidth: "10px",
                        maxWidth: "10px",
                        padding: "0.2rem",
                    },
                    tdStyle: {
                        width: "10px",
                        minWidth: "10px",
                        maxWidth: "10px",
                        padding: "0.2rem",
                    },
                },
                {
                    key: "tipo",
                    label: "Attività",
                    thClass: "colonna-fissa-attivita align-middle text-left",
                    tdClass: "colonna-fissa-attivita text-left",
                    thStyle: {
                        width: "260px",
                        minWidth: "260px",
                        maxWidth: "260px",
                        padding: "0.3rem",
                    },
                    tdStyle: {
                        width: "260px",
                        minWidth: "260px",
                        maxWidth: "260px",
                        padding: "0.3rem",
                    },
                },
                ...timestampOrdinati.map((ts) => {
                    const dateObj = new Date(ts);
                    const data = dateObj.toLocaleDateString("it-IT");
                    const ora = dateObj.toLocaleTimeString("it-IT", {
                        hour: "2-digit",
                        minute: "2-digit",
                    });

                    const isNuovoGruppo = data !== lastDate;

                    if (isNuovoGruppo) {
                        gruppiDiDate.push({ date: data, count: 1 });
                        lastDate = data;
                    } else {
                        gruppiDiDate[gruppiDiDate.length - 1].count++;
                    }

                    return {
                        key: ts.toString(),
                        label: ora,
                        thClass: `text-center align-middle${isNuovoGruppo ? " sa-bordo-gruppo" : ""}`,
                        tdClass: `text-center align-middle${isNuovoGruppo ? " sa-bordo-gruppo" : ""}`,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        tdStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                    };
                }),
            ];

            this.dateGroups = gruppiDiDate;
            this.fields = colonne;
            const righeTemporanee = dati.reduce((acc, { ts, tipo, valore }) => {
                if (!acc[tipo]) {
                    acc[tipo] = { tipo };
                }
                acc[tipo][ts] = valore;
                return acc;
            }, {});

            this.items = Object.values(righeTemporanee);
        },
    },
};
</script>
<style scoped>
/* =========================================
   WRAPPER
========================================= */
.table-wrapper {
    width: 100%;
    max-height: 65vh;
    overflow: auto;
    position: relative;
}

/* =========================================
   TABELLA BASE
========================================= */
::v-deep .sa-b-table {
    min-width: max-content;
    border-collapse: separate;
    border-spacing: 0;
}

::v-deep .sa-b-table th,
::v-deep .sa-b-table td {
    padding: 0.35rem !important;
    vertical-align: middle;
    white-space: nowrap;
}

/* =========================================
   HEADER 1: RIGA DELLE DATE (TUTTA BLU)
========================================= */
::v-deep .sa-riga-date th {
    position: sticky !important;
    top: 0 !important;
    height: 40px !important;
    box-sizing: border-box;
    background-color: #0ea5e9 !important;
    color: white !important;
    border: none !important;
    z-index: 100 !important;
}

::v-deep .sa-riga-date th.colonna-vuota-top-left {
    left: 0 !important;
    z-index: 120 !important;
    background-color: #0ea5e9 !important;
    border-right: 1px solid #0ea5e9 !important;
}

/* =========================================
   HEADER 2: RIGA DEGLI ORARI (TUTTA BIANCA)
========================================= */
::v-deep .sa-riga-orari th {
    position: sticky !important;
    top: 40px !important;
    z-index: 90 !important;
    background-color: white !important;
    border-bottom: 2px solid #dee2e6 !important;
}

/* =========================================
   COLONNE FISSE (Corpo e Intestazioni)
========================================= */

/* Posizionamento base Indice */
::v-deep .sa-b-table td.colonna-fissa-indice,
::v-deep .sa-riga-orari th.colonna-fissa-indice {
    position: sticky !important;
    left: 0 !important;
}

/* Posizionamento base Attività */
::v-deep .sa-b-table td.colonna-fissa-attivita,
::v-deep .sa-riga-orari th.colonna-fissa-attivita {
    position: sticky !important;
    left: 30px !important;
    width: 260px !important;
    min-width: 260px !important;
    max-width: 260px !important;
    border-right: 2px solid #dfe3e8 !important;
}

/* Z-index per gli Header */
::v-deep .sa-riga-orari th.colonna-fissa-indice,
::v-deep .sa-riga-orari th.colonna-fissa-attivita {
    z-index: 110 !important;
    background-color: white !important;
}

/* Z-index per il Body */
::v-deep .sa-b-table td.colonna-fissa-indice,
::v-deep .sa-b-table td.colonna-fissa-attivita {
    z-index: 80 !important;
}

/* =========================================
   COLORI RIGHE ALTERNATE PER COLONNE FISSE
========================================= */

/* Righe Pari (Bianche) */
::v-deep .sa-b-table tbody tr:nth-of-type(even) td.colonna-fissa-indice,
::v-deep .sa-b-table tbody tr:nth-of-type(even) td.colonna-fissa-attivita {
    background-color: #ffffff !important;
}

/* Righe Dispari (Grigio Chiaro - Effetto Striped) */
::v-deep .sa-b-table tbody tr:nth-of-type(odd) td.colonna-fissa-indice,
::v-deep .sa-b-table tbody tr:nth-of-type(odd) td.colonna-fissa-attivita {
    background-color: #f2f2f2 !important; /* Colore standard Bootstrap striped */
}

/* Effetto Passaggio Mouse (Hover) */
::v-deep .sa-b-table tbody tr:hover td.colonna-fissa-indice,
::v-deep .sa-b-table tbody tr:hover td.colonna-fissa-attivita {
    background-color: #ececec !important; /* Grigio leggermente più scuro per l'hover */
}

/* =========================================
   COLONNE NORMALI
========================================= */
::v-deep .sa-b-table th:not(.colonna-fissa-attivita):not(.colonna-fissa-indice),
::v-deep .sa-b-table td:not(.colonna-fissa-attivita):not(.colonna-fissa-indice) {
    min-width: 90px;
    width: 90px;
}

/* =========================================
   CONTENUTO ATTIVITA E RIMOZIONE RIGA BLU
========================================= */
::v-deep .contenuto-attivita {
    white-space: normal;
    word-break: break-word;
}

/* Riga blu rimossa! */
::v-deep .sa-bordo-gruppo {
    border-left: none !important;
}

/* =========================================
   SCROLLBAR
========================================= */
.table-wrapper::-webkit-scrollbar {
    height: 10px;
    width: 10px;
}
.table-wrapper::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 20px;
}
.table-wrapper::-webkit-scrollbar-track {
    background: #f1f5f9;
}
</style>
